import React from 'react';
import { Button } from '@audi/audi-ui-react';
import Icon360 from '../../assets/icons/Icon360';
import { ButtonWrapper, IconWrapper } from './Impel360CTA.style';

interface Impel360CTAProps {
  isVisible: boolean;
  label: string;
  color: string;
  isNew: boolean;
  isT3: boolean;
}

const Impel360CTA: React.FC<Impel360CTAProps> = ({ isVisible, label, color, isNew, isT3 }) => {
  const labelText = !label || label?.length === 0 ? 'view vehicle tour' : label;
  const labelTextFormatted = labelText.charAt(0).toUpperCase() + labelText.slice(1);

  return (
    <ButtonWrapper isVisible={isVisible} color={color} isNew={isNew} isT3={isT3}>
      <Button
        id="vendorIntegrations__impel"
        variant="text"
        size="small"
        type="button"
        aria-label="View vehicle tour"
        data-testid="impel360-cta"
      >
        <IconWrapper color={color}>
          <Icon360 />
        </IconWrapper>
        {labelTextFormatted}
      </Button>
    </ButtonWrapper>
  );
};
export default Impel360CTA;
